import { Autocomplete, Button, Chip, CircularProgress, TextField } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';

/*  Props are
1) - options
2) - onChangeHandler
3) - renderInput
4) - multiple - default false
5) - optionKey - to tell which key identify unique in array of object
6)- disabled

*/

function ComboBox({ multiple = false, ...props }) {
    const [comboBoxOptions, setComboBoxOptions] = useState([]);
    const [comboBoxSelectedValue, setComboBoxSelectedValue] = useState(multiple ? [] : null);
    const [defaultValue, setDefaultValue] = useState(multiple ? [] : null);
    const [open, setOpen] = useState(false);
    const loading = open && comboBoxOptions.length === 0;

    useEffect(() => {
        if (props?.options) {
            setComboBoxOptions(props.options);
        }
    }, [props?.options]);

    useEffect(() => {
        if (props?.defaultValue) {
            setDefaultValue(props.defaultValue);
            setComboBoxSelectedValue(props.defaultValue);
            if (props?.onChangeHandler) {
                props.onChangeHandler(props.defaultValue);
            }
        }
    }, [props.defaultValue]);

    const handleDefaultChange = (event, value) => {
        // Default change handler does nothing
    };

    const renderDefaultInput = (params) => (
        <TextField {...params}
            InputProps={{
                ...params.InputProps,
                endAdornment: (
                    <Fragment>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                    </Fragment>
                ),
            }}
            label={props.headKey} variant="outlined" />
    );

    const renderTags = (tagValue, getTagProps) => {
        if (multiple) {
            return tagValue.map((option, index) => {
                const { key, ...tagProps } = getTagProps({ index }); // Destructure key out of tagProps
                return (
                    <Chip
                        label={option.label}
                        key={option[props.optionKey] || index} // Ensure each key is unique
                        {...tagProps}
                    />
                );
            });
        }
        return null;
    };

    const onChangeHandler = (e, item) => {
        setComboBoxSelectedValue(item);
        if (props?.onChangeHandler) {
            props.onChangeHandler(item);
        }
    };

    return (
        <Autocomplete
            id="combo-box-demo"
            size='small'
            disableClearable
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            loading={loading}
            disabled={props?.disabled ? props.disabled : false}
            getOptionKey={(option) => option[props.optionKey]}


            renderTags={renderTags}
            defaultValue={defaultValue}
            multiple={multiple}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => option[props.optionKey] === value[props.optionKey]}
            options={comboBoxOptions}
            onChange={onChangeHandler}
            value={comboBoxSelectedValue}
            renderInput={props?.renderInput || renderDefaultInput}
        />
    );
}

export default ComboBox;

// // Usage example in another component
// const App = () => {
//     const options = [
//         { label: 'Demo 1', id: 1 },
//         { label: 'Demo 2', id: 2 },
//         { label: 'Demo 3', id: 3 },
//     ];
//     const defaultValue = { label: 'Demo 2', id: 2 };

//     return (
//         <div>
//             <ComboBox
//                 options={options}
//                 value={defaultValue}
//                 onChangeHandler={(value) => console.log('Selected:', value)}
//                 optionKey="id"
//                 multiple={true} // Change to false to test single selection
//             />
//         </div>
//     );
// };

// export default App;
